import styled from 'styled-components';

// styles
export const Wrapper = styled.div`
    width: 30%;
    height: auto;
    .text {
        color: #61788E;
        font-size: 13px;
        font-weight: 700; 
        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
    .button {
        background-color: white !important;
        border: 1px solid #61788E !important;
        border-radius: 8px !important;
        width: 100%;
    }
`